import Header from "../../Common/Header";
import { Link } from "react-router-dom";
import { FaAngleLeft } from "react-icons/fa6";
import { FaChevronRight } from "react-icons/fa6";
import { FaCheck } from "react-icons/fa";

const AboutAsset = () => {
  return (
    <>
      <Header />
      <div className="container">
        <div className="grid grid-cols-2 mt-[15px] max-lg:grid-cols-1">
          <div>
            <div>
              <p className="font-semibold text-[22px] sm:text-[24px] md:text-[26px] lg:text-[28px]">About your assets</p>
              <p className="my-3 text-slate-500">
                Here, you can tell your executors where to find the different
                assets that make up your estate.
              </p>
              <p className="my-3 text-slate-500">
                This section is optional, but it can be incredibly helpful for
                the people you might leave behind.
              </p>
              <p className="my-3 text-slate-500">What to include.</p>
              <div className="my-4">
                <div>
                  <p className="flex mt-3 text-slate-500 items-center gap-5">
                    <FaCheck className="text-[#7a3db6]" /> Bank and building
                    society accounts
                  </p>
                  <p className="flex mt-3 text-slate-500 items-center gap-5">
                    <FaCheck className="text-[#7a3db6]" /> Pensions
                  </p>
                  <p className="flex mt-3 text-slate-500 items-center gap-5">
                    <FaCheck className="text-[#7a3db6]" /> Funeral plan
                  </p>
                  <p className="flex mt-3 text-slate-500 items-center gap-5">
                    <FaCheck className="text-[#7a3db6]" /> Life insurance
                    policies
                  </p>
                </div>
              </div>
              <p className="my-3 text-slate-500">
                Don’t worry if you can’t remember everything! Just add what you
                can..
              </p>
              <p className="my-3 text-slate-500">
                You don’t need to record access details like account numbers,
                usernames and passwords - people just need to know where things
                are rather than being able to prove you own them
              </p>
            </div>
            <div className="py-5 border-b-2">
              <div className="border-black rounded-xl border-[1px] p-3">
                <div className="flex gap-5">
                  <div className="w-[15%]">
                    <img src="/assets/images/write-icon.png" alt="write" />
                  </div>
                  <div className="w-[100%]">
                    <p className="text-[20px] my-3 font-bold">
                      Life changes...so should your will
                    </p>
                    <p className="text-[16px] text-slate-500">
                      Think you’ve missed something? Don’t worry: with unlimited
                      updates, you can come back and add new assets to your will
                      any time..
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <p className="my-1 text-slate-500"></p>

            <div className="pt-5 flex justify-between items-center">
              <div className="flex  pb-5">
                <Link to={"/dashboard"}>
                  <button className="flex items-center justify-center gap-1 font-semiold text-[20px] py-2 rounded-[10px] text-slate-500">
                    <FaAngleLeft />
                    Back
                  </button>
                </Link>
              </div>
              <div className="flex  pb-5">
                <Link to={"/make-will-online/assets/select"}>
                  <button className="bg-primary px-5 py-3 text-white font-muli font-semibold rounded-[5px] flex items-center gap-1">
                    Next <FaChevronRight />
                  </button>
                </Link>
              </div>
            </div>
          </div>

          <div>
            <div className="max-lg:hidden bg-no-repeat ">
              <div className="fixed top-[100px] w-[500px] right-[6%]">
                <img src="/assets/images/10.png" alt="mascot" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutAsset;
